// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"7270759a","442":"60d83371","589":"001f23e3","609":"2dc8abdd","616":"c8d84cf4","850":"39ff307d","873":"7c3e061a"}[chunkId] + ".chunk.css";
};